import React from 'react';
import styles from '../AddRateModal.module.scss';
import {useTranslation} from 'react-i18next';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {useStylesBox} from './styleCustom';

interface TitleSelectProps {
    selectValue: {[key: string]: string};
    setAddObj: React.Dispatch<React.SetStateAction<any>>;
};

const contentMapping: any = {
    instagram: ['IG Reel', 'IG Story', 'IG Photo'],
    twitter: ['Tweet', 'Quote Re-tweet'],
    youtube: ['Integration (60s-90s)', 'Full Video'],
    tiktok: ['Video', 'Live'],
    snapchat: ['Story', 'Spotlight'],
    linkedin: ['Post'],
};

const ContentSelector = ({selectValue, setAddObj}: TitleSelectProps) => {
    const {t} = useTranslation();
    const classesInput = useStylesBox();

    return (
        <div className={`${styles.rowBox} ${styles.fullwidth}`}>
            <div className={styles.rowTop} style={{display: 'flex'}}>
                <div dir="ltr" className={`${styles.dropdown} ${styles.input} ${styles.clicked}`}>
                    <Select
                        labelId="social-platform-selector"
                        id="social-platform-selector"
                        style={{width: '100%', height: '56px', padding: '6px 10px', marginRight: '0.2rem', fontSize: '16px', fontWeight: 400, background: 'white', borderRadius: '26px', borderBottom: '1px solid rgba(217, 217, 217, 0.6)'}}
                        value={selectValue.contentType}
                        className={classesInput.textField}
                        onChange={(e: any) => {
                            setAddObj({...selectValue, contentType: e.target.value});
                        }
                        }
                    >
                        {contentMapping[selectValue?.platform].map((ele: any) => <MenuItem key={`social-name-${ele}`} value={ele}>{ele}</MenuItem>)}
                    </Select>
                </div>
            </div>
        </div>
    );
};

export default ContentSelector;
